@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div cdkDrag class="popup_main_div add_edit_estimate_main" cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>{{ dialogTitle }}</span>
    <button class="btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form [formGroup]="estimateform" fxLayout="column" fxFlex="1 0 auto" name="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="auto"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.ITEMTYPE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ITEMTYPE),
            }"
          >
            <mat-label>Select an option</mat-label>
            <mat-select
              formControlName="ITEMTYPE"
              #value
              name="selected"
              (selectionChange)="TypeChange($event, '')"
            >
              <mat-option value="Time Entry">Time Entry</mat-option>
              <mat-option value="Activity">Activity</mat-option>
              <mat-option value="Matter Expense">Matter Expense</mat-option>
              <mat-option value="Sundry">Sundry</mat-option>
              <mat-option value="Search">Search</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="auto"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.FEEEARNER),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FEEEARNER),
            }"
          >
            <mat-label>Fee Earner</mat-label>
            <mat-select
              #value
              name="selected"
              (selectionChange)="matterChange('FeeEarner', $event.value)"
              formControlName="FEEEARNER"
            >
              @for (user of userList; track user) {
                <mat-option value="{{ user.USERID }}">
                  {{ user.FULLNAME }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (RATEIDValue) {
            <mat-form-field
              appearance="outline"
              fxFlex="17"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.rateid),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.rateid),
              }"
            >
              <mat-label>Rate ID</mat-label>
              <!-- [disabled] = " _data.edit == 'Add'" -->
              <mat-select formControlName="RATEID" (selectionChange)="reateId($event.value)">
                @for (rateids of RATEIData; track rateids) {
                  <mat-option [(value)]="rateids.LOOKUPGUID">
                    {{ rateids.LOOKUPFULLVALUE }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (ITEMTYPEValue) {
            <mat-form-field appearance="outline" fxFlex="auto" class="pr-1">
              @if (lookuptype == 'Activities' || lookuptype == 'Activity') {
                <mat-label>Activity</mat-label>
              }
              @if (lookuptype == 'Sundries' || lookuptype == 'Sundry') {
                <mat-label>Sundry</mat-label>
              }
              <input type="text" matInput formControlName="QUANTITYTYPE" [matAutocomplete]="auto" />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="ActivityChnage($event.option.value)"
              >
                @for (Activity of filteredOptionsActivity | async; track Activity) {
                  <mat-option [value]="Activity.ACTIVITYID">
                    {{ Activity?.ACTIVITYID }}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {{ Activity.DESCRIPTION }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.SERVICE,'has-warning':errorWarningData.Warning?.SERVICE}">
          <mat-label>Service</mat-label>
          <textarea type="text" matInput type="text" matInput formControlName="SERVICE"  style=" min-height: 51px;" [matAutocomplete]="serviceText"></textarea>
          <mat-autocomplete #serviceText="matAutocomplete" (optionSelected)="ServiceChnage($event.option.value)">
            <mat-option *ngFor="let Service of filteredOptions | async" [value]="Service.LOOKUPFULLVALUE">{{Service.LOOKUPFULLVALUE}}</mat-option>
          </mat-autocomplete>
        </mat-form-field> -->

          <mat-form-field
            appearance="outline"
            class="full-width pr-1"
            fxFlex="100"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData?.Error?.SERVICE),
              'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.SERVICE),
            }"
          >
            <mat-label>Service</mat-label>

            <textarea
              matInput
              formControlName="SERVICE"
              [matAutocomplete]="serviceText"
              rows="2"
              style="min-height: 51px"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>

            <mat-autocomplete
              #serviceText="matAutocomplete"
              (optionSelected)="ServiceChnage($event.option.value)"
            >
              @for (service of filteredOptions | async; track service) {
                <mat-option [value]="service.LOOKUPFULLVALUE">
                  {{ service.LOOKUPFULLVALUE }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="25"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.MINQUATITY),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MINQUATITY),
            }"
          >
            <mat-label>Min. Quantity</mat-label>
            <input
              formControlName="MINQUATITY"
              matInput
              [disabled]="isdisable"
              (focusout)="matterChange('Quantity', $event.value)"
            />
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="25"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.MINTYPE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MINTYPE),
            }"
          >
            <mat-label>Min. Type:</mat-label>
            <mat-select
              #value
              name="selected"
              (selectionChange)="quantityTypeChange('QuantityType', $event.value)"
              formControlName="MINTYPE"
            >
              @for (Activity of ActivityList; track Activity) {
                <mat-option value="{{ Activity.ACTIVITYID }}">
                  {{ Activity.DESCRIPTION }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="25"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.MINPRICE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MINPRICE),
            }"
          >
            <mat-label>Min. Price</mat-label>
            <!-- numeric numericType="decimal" -->
            <!-- type="float" (blur)="amountChange($event, 'MINPRICE')" -->
            <input
              type="text"
              mask="separator.2"
              thousandSeparator=","
              decimalMarker="."
              style="text-align: right"
              formControlName="MINPRICE"
              matInput
              [readonly]="isreadonly"
              (blur)="calcPE()"
              [(ngModel)]="PRICEVAL"
              [allowNegativeNumbers]="true"
              [leadZero]="true"
            />
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="25"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.MININCGST),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MININCGST),
            }"
          >
            <mat-label>Min. Inc GST</mat-label>
            <!-- type="text" mask="separator.2" thousandSeparator="," decimalMarker="."  -->
            <!-- (blur)="amountChange($event, 'MINPRICE')" -->
            <input
              type="text"
              mask="separator.2"
              thousandSeparator=","
              decimalMarker="."
              style="text-align: right"
              [allowNegativeNumbers]="true"
              formControlName="MININCGST"
              matInput
              [readonly]="isreadonly"
              (blur)="calcPI()"
              [(ngModel)]="PRICEINCGSTVAL"
              [leadZero]="true"
            />
          </mat-form-field>
        </div>

        @if (AllowEstimateRange) {
          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <mat-form-field
              appearance="outline"
              fxFlex="25"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.MAXQUATITY),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MAXQUATITY),
              }"
            >
              <mat-label>Max. Quantity</mat-label>
              <input
                formControlName="MAXQUATITY"
                matInput
                (focusout)="matterChange('Quantity', $event.value, 'max')"
              />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              fxFlex="25"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.MAXTYPE),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MAXTYPE),
              }"
            >
              <mat-label>Max. Type:</mat-label>
              <mat-select
                #value
                name="selected"
                (selectionChange)="quantityTypeChange('QuantityType', $event.value, 'max')"
                formControlName="MAXTYPE"
              >
                @for (Activity of ActivityList; track Activity) {
                  <mat-option value="{{ Activity.ACTIVITYID }}">
                    {{ Activity.DESCRIPTION }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              fxFlex="25"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.MAXPRICE),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MAXPRICE),
              }"
            >
              <mat-label>Max. Price</mat-label>
              <!-- numeric numericType="decimal"  -->
              <input
                type="text"
                mask="separator.2"
                thousandSeparator=","
                decimalMarker="."
                style="text-align: right"
                [allowNegativeNumbers]="true"
                formControlName="MAXPRICE"
                matInput
                [readonly]="isreadonly"
                (blur)="calcPE('max')"
                [(ngModel)]="MAXPRICEVAL"
                [leadZero]="true"
              />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              fxFlex="25"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.MAXINCGST),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.MAXINCGST),
              }"
            >
              <mat-label>Max. Inc GST</mat-label>
              <input
                type="text"
                mask="separator.2"
                thousandSeparator=","
                decimalMarker="."
                style="text-align: right"
                [allowNegativeNumbers]="true"
                formControlName="MAXINCGST"
                matInput
                [readonly]="isreadonly"
                (blur)="calcPI('max')"
                [(ngModel)]="MAXPRICEINCGSTVAL"
                [leadZero]="true"
              />
            </mat-form-field>
          </div>
        }
      </form>
    </div>
    <mat-dialog-actions class="popup_ftr justify-end!">
      @if (action === 'new') {
        <button
          matButton="filled"
          class="mat-accent"
          (click)="EstimateSave()"
          [disabled]="isspiner"
        >
          @if (isspiner) {
            <mat-spinner diameter="24"></mat-spinner>
          }
          Save
        </button>
      }
      @if (action === 'edit') {
        <button
          matButton="filled"
          class="mat-accent"
          (click)="EstimateSave()"
          [disabled]="isspiner"
        >
          @if (isspiner) {
            <mat-spinner diameter="24"></mat-spinner>
          }
          Update
        </button>
      }
      @if (action !== 'new' && action !== 'edit') {
        <button
          matButton="filled"
          class="mat-accent"
          (click)="EstimateSave()"
          [disabled]="isspiner"
        >
          @if (isspiner) {
            <mat-spinner diameter="24"></mat-spinner>
          }
          Duplicate
        </button>
      }
      <button matButton="tonal" class="mat-accent" [mat-dialog-close]="false" cdkFocusInitial>
        Don't Save
      </button>
    </mat-dialog-actions>
  </div>
</div>
